<div class="wraper">
  <div class="loaded-content">
    <div class="grid">
      <div class="col-5">
        <div class="col-12">
          <h3>Load Rack</h3>
          <form #loadRackForm="ngForm">
            <label [hidden]="rack.SerialNumber" class="p-m-2">Rack Serial Number: </label>
            <label [hidden]="!rack.SerialNumber || rackIsFull" class="p-m-2">Accession Number: </label>
            <H3 [hidden]="!rackIsFull" class="p-m-2">Rack is full - click Change Rack to load another one</H3>
            <input #searchTracking name="searchTracking" type="text" [(ngModel)]="trackingId" [hidden]="rackIsFull" placeholder="{{searchTrackingHelpText}}">
            <button (click)="handleSearchButton()" style="margin-left:10px; padding:4px" [hidden]="rackIsFull"><i class="fa fa-search fa-3x"></i></button>
          </form>
        </div>
        <div class="col-12">
          <div *ngIf="rack.Id">
            <div class="grid">
              <div class="col-6">
                <h4>Rack</h4>
                <div>
                  <label>Serial Number: </label>
                  <b> {{rack.SerialNumber}}</b>
                </div>
              </div>
              <div class="col-6">
                <p-button [hidden]="!rack.SerialNumber" class="p-button-success p-button-rounded" (click)="changeRack()" icon="pi pi-check" label="Change Rack"></p-button>
              </div>
            </div>
            <div class="col-12">
              <div class="grid">
                <div class="col">
                  <table>
                    <tr>
                      <th></th>
                      <th *ngFor="let r of [].constructor(rack.RackType.Cols); let i = index">{{columnName[i]}}</th>
                    </tr>
                    <tr *ngFor="let c of [].constructor(rack.RackType.Rows); let x = index">
                      <td>{{x+1}}</td>
                      <td *ngFor="let r1 of [].constructor(rack.RackType.Cols); let y = index" style="width: 34px;">
                        <i class="fad fa-badge" [style.--fa-primary-color]="getColor(x, y)" style="--fa-primary-opacity: 1.0; --fa-secondary-opacity: 1.0;" title="{{getAccession(x, y)}}"></i>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-7">
        <div *ngIf="rack.Id">
          <p-virtualscroller #vs [items]="rack.Contents" scrollHeight="500px" [itemSize]="50">
            <!--<ng-template pTemplate="header">
              Contents of Rack: {{rack.SerialNumber}}
            </ng-template>-->
            <ng-template #item let-cell let-options="options">
              <div class="grid">
                <div class="col-1">
                  <h5 style="vertical-align: top !important; display: inline">{{cell.Row | rackLocation: cell.Col}}</h5>
                </div>
                <div class="col-2">
                  <span style="vertical-align: top !important">{{cell.Accession}}</span>
                </div>
                <div class="col-4">
                  <span>{{cell.FirstName}} {{cell.LastName}}</span>
                </div>
                <div class="col-2">
                  {{cell.AddedDate | date:'MM/dd/yyyy HH:mm'}}
                </div>
                <div class="col-3">
                  <span class="rounded-pill pl-2 pr-2" [ngClass]="{
                          'bg-red-400': cell.StatusText == 'Rejected',
                          'bg-yellow-400': cell.StatusText == 'Exceptions',
                          'bg-green-400': cell.StatusText != 'Rejected' && cell.StatusText != 'Exceptions'
                          }">{{cell.StatusText}}</span>
                </div>
              </div>
            </ng-template>
          </p-virtualscroller>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog [(visible)]="showNewRackDialog" header="Setup New Rack" modal="true">
  <h3>Rack not found - setup new Rack</h3>
  <div class="ui-fluid p-formgrid grid">
    <div class="p-field col-12 p-md-4">
      <label for="serialNumber">Serial Number</label>
      <input id="serialNumber" type="text" [(ngModel)]="rack.SerialNumber" pInputText>
    </div>
    <div class="p-field col-12 p-md-4">
      <label for="rackType">Rack Type</label>
      <p-select inputId="rackType" [options]="rackTypes" [(ngModel)]="rack.RackTypeCode" placeholder="Select" optionLabel="name" appendTo="body"></p-select>
    </div>
    <div class="p-field col-12 p-md-4">
      <label for="department">Department</label>
      <p-select inputId="department" [options]="departments" [(ngModel)]="rack.DepartmentId" placeholder="Select" optionLabel="name" appendTo="body"></p-select>
    </div>
  </div>
  <div class="grid p-jc-center">
    <p-button (click)="addRack()" icon="pi pi-check" label="Save" class="p-button-lg p-m-2"></p-button>
  </div>
</p-dialog>

<p-dialog [(visible)]="showCantLoadDialog" header="{{dialogHeading}}" modal="true">

  <div style="min-height: 125px" class="alert alert-danger" role="alert" [hidden]="!cantLoad">
    <h3>{{loadMessage}}</h3>
    <div class="grid p-jc-center">
      <p-button class="p-button-lg p-m-2" (click)="clearCell()" icon="pi pi-times" label="Dismiss"></p-button>
    </div>
  </div>

  <div style="min-height: 125px" class="alert alert-success" role="alert" [hidden]="cantLoad">
    <form autocomplete="off">
      <div class="p-formgorup-inline">
        <div class="p-field">
          <label for="firstname" class="p-sr-only">First Name</label>
          <input id="firstname" name="firstname" type="text" pInputText placeholder="First name" [(ngModel)]="requisition.FirstName" autocomplete="none">
        </div>
        <div class="p-field">
          <label for="lastname" class="p-sr-only">Last Name</label>
          <input id="lastname" name="lastname" type="text" pInputText placeholder="Last name" [(ngModel)]="requisition.LastName" autocomplete="none">
        </div>
        <div class="p-field">
          <p-datepicker inputId="birthDate" id="birthDate" name="birthDate" [showOnFocus]="false" [(ngModel)]="requisition.BirthDate" [minDate]="minDateValue" [maxDate]="maxDateValue" placeholder="Birth Date" autocomplete="none"></p-datepicker>
        </div>
      </div>
    </form>
    <h3>{{loadMessage}}</h3>
    <p-button class="p-button-success p-button-lg p-m-2" (click)="saveLocation()" icon="pi pi-check" label="Save"></p-button>
    <p-button class="p-button-danger  p-button-lg p-m-2" (click)="clearCell()" icon="pi pi-times" label="Cancel"></p-button>
  </div>
</p-dialog>

<p-toast>
</p-toast>

<p-blockUI [blocked]="loading">
  <i class="pi pi-lock" style="font-size: 3rem"></i>
</p-blockUI>
